<app-editable-table-filter #PaymentsEditableTable
[headers]="[ {name:'id'},{name:'date',type:'date'},{name:'nro'},{name:'vendor_name'},{name:'amount'},{name:'currency_id',type:'selectList'},{name:'exchange_rate'},{name:'total_books'},{name:'contract_id'},{name:'voucher_id'},{name:'total_vendor'},{name:'source',type:'autocomplete'},{name:'purchase_journal_id',type:'selectList'},{name:'file_id'}]"
[data]='dataSource'
updateUrl="{{'contracts/budgets/update/'}}"
newUrl="{{'contracts/budgets/store/'}}"
removeUrl="{{'accounting/payments/remove'}}"
>
</app-editable-table-filter>
